module.exports = __webpack_public_path__ + "static/img/weather_029.c33274dc.svg";